import { Partner } from '../model/Partner';

export const partners: Partner[] = [
  {
    key: 's4dx',
    name: 'Smart4Diagnostics',
    logo: 's4dx.svg',
    url: 'https://smart4diagnostics.com/',
  },
];
